



















































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import AppConsts from "@/lib/appconst";
import PagedFilterAndSortedRequest from "@/store/entities/page-request";
import pagelist from "@/components/pagelistcomponent";
import daifuordersubmit from "./OrdersEdit.vue";
var that;
@Component({
  components: { daifuordersubmit },
})
export default class suppliermanage extends pagelist {
  get prox() {
    return new proxy.PayOrderServiceProxy();
  }
  refreshsec = 15;
  autorefresh = false;
  pageSize = 50;
  input: proxy.PayOrderPageInputDto = new proxy.PayOrderPageInputDto();
  sub_id = 0;
  createOrEditShow = false;
  modalsetcommentshow = false;
  setcommentorder = {} as any;
  comment = "";
  PayChannels = [];
  createrange = [];
  successrange = [];
  updateOrderMoney = 0;
  updateOrderMoneyShow = false;
  // todaytotal = new proxy.QueryModelListTotalOutDto();
  // listtotal = new proxy.QueryModelListTotalOutDto();
  statustotal = [];
  canceltimes = [];
  successtotal = new proxy.QuerySuccessTotalOutDto();
  columns: any[] = [];
  twidth = 100;
  merchants = [];
  ctypes = [];
  googlecode = "";
  czshow = false;
  bdshow = false;
  startMoney = undefined;
  endMoney = undefined;
  supps = []

  options = {
    shortcuts: [
      {
        text: '今天',
        value() {
          const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000);
          const start = new Date(new Date(new Date().toLocaleDateString()).getTime());
          return [start, end]
        }
      },
      {
        text: '昨天',
        value() {
          const end = new Date(new Date(new Date().toLocaleDateString()).getTime());
          const start = new Date(new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24);
          return [start, end]
        }
      },
      {
        text: '三天',
        value() {
          const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000);
          const start = new Date(new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24 * 2);
          return [start, end]
        }
      },
      {
        text: '一周',
        value() {
          const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000);
          const start = new Date(new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24 * 6);
          return [start, end]
        }
      }
    ]
  }

  allcolumns: any[] = [
    {
      type: "selection",
      width: 60,
      align: "center",
      title: "选择框",
    },
    {
      title: "系统单号",
      slot: "tid",
      width: 180,
      resizable: true,
    },
    {
      title: "商户单号",
      slot: "merOrderTid",
      width: 180,
      resizable: true,
    },
    {
      title: "商户",
      slot: "merchantName",
      width: 200,
      resizable: true,
    },
    // {
    //   title: "商户号",
    //   slot: "mid",
    //   width: 100,
    // },
    {
      title: "上游通道",
      slot: "channelName",
      width: 230,
      resizable: true,
    },
    // {
    //   title:'通道费率',
    //   slot:'channelRate',
    //   width:110
    // },
    {
      title: "产品",
      slot: "payChannelName",
      width: 230,
      resizable: true,
    },

    {
      title: "金额",
      slot: "money",
      width: 120,
    },

    {
      title: "订单状态",
      slot: "payOrderStatusName",
      width: 140,
    },
    {
      title: "通知状态",
      slot: "noticeStatus",
      width: 120,
    },

    {
      title: "创建时间",
      key: "creationTime",
      width: 180,
    },
    {
      title: "成功时间",
      key: "successTime",
      width: 180,
    },
    {
      title: "是否修改金额",
      slot: "isUpdateMoney",
      width: 130
    },
    {
      title: "是否补单",
      slot: "isBuDan",
      width: 100,
    },
    {
      title: "是否冲正",
      slot: "isCz",
      width: 110,
    },


    {
      title: "失败时间",
      key: "failTime",
      width: 180,
    },
    {
      title: "关闭时间",
      key: "endTime",
      width: 180,
    },
    {
      title: "利润",
      slot: "lirun",
      width: 100,
    },
    {
      title: "手续费",
      slot: "commission",
      width: 100,
    },
    {
      title: '通道代理佣金',
      slot: 'agentRateCommission',
      width: 120
    },
    {
      title: '商户代理佣金',
      slot: 'merchantAgentRateCommission',
      width: 120
    },
    {
      title: "支付耗时",
      slot: "payTimeConsuming",
      width: 150,
    },
    {
      title: "备注",
      key: "orderCommont",
      width: 200,
    },
    {
      title: "付款人备注",
      key: "clientUserPayRemark",
      width: 140,
    },
    {
      title: "商户端用户id",
      key: "clientUserId",
      width: 140,
    },
    {
      title: "商户端用户昵称",
      key: "clientUserName",
      width: 140,
      tooltip: true
    },
    {
      title: "会员IP",
      key: "orderApiIps",
      width: 140
    },
    {
      title: "操作",
      slot: "opera",
      fixed: "right",
      width: 240,
    },
  ];

  selecttitles = [];
  format(val) {
    return "每 " + val + "秒自动刷新一次";
  }
  editsuccess(e) {
    if (e == 1) {
      let m = that.dataList.find(
        (x) =>
          x.daiFuOrderType == 0 &&
          (x.daiFuPay == 0 || x.daiFuPay == 2) &&
          x.id < this.sub_id
      );
      if (m) {
        setTimeout(() => {
          this.daifusubmit(m);
        }, 200);
      }
    } else {
      this.getpage();
    }
  }

  fetchDataList(
    request: PagedFilterAndSortedRequest,
    pageNumber: number,
    finishedCallback: Function
  ): void {
    this.input.skipCount = request.skipCount;
    this.input.maxResultCount = request.maxResultCount;
    this.input.sorting = request.sorting;
    this.input.createStartTime = this.createrange[0];
    this.input.createEndTime = this.createrange[1];
    this.input.successStartTime = this.successrange[0];
    this.input.successEndTime = this.successrange[1];
    this.input.cancelTimeStart = this.canceltimes[0];
    this.input.cancelTimeEnd = this.canceltimes[1];
    this.input.startMoney = this.startMoney;
    this.input.endMoney = this.endMoney;
    this.prox.queryPageList(this.input).then((x) => {
      console.time('t1');
      if (x.items.length) {

        let midwidth = 0;
        let channelRatewidth = 0;
        let payChannelNamewidth = 0;
        x.items.map(p => {
          let _midwidth = this.pxWidth(p.mid + p.merchantName);
          if (_midwidth > midwidth) {
            midwidth = _midwidth
          }
          let _channelRatewidth = this.pxWidth(p.channelRate + p.channelName);
          if (_channelRatewidth > channelRatewidth) {
            channelRatewidth = _channelRatewidth
          }
          let _payChannelName = this.pxWidth(p.channelTypeCode + p.channelTypeName);
          if (_payChannelName > payChannelNamewidth) {
            payChannelNamewidth = _payChannelName
          }
        })

        let mid_c = this.columns.find(x => x.slot == 'merchantName');
        if (mid_c) {
          mid_c.width = midwidth + 50;
        }

        let channelName_c = this.columns.find(x => x.slot == 'channelName');
        if (channelName_c) {
          channelName_c.width = channelRatewidth + 60;
        }

        let payChannelName_c = this.columns.find(x => x.slot == 'payChannelName');
        if (payChannelName_c) {
          payChannelName_c.width = payChannelNamewidth + 60;
        }

      }
      console.timeEnd('t1')
      this.dataList = x.items;
      this.showPaging(x);
    });

  }
  batchsuccess() {
    if (this.selectedDataItems.length == 0) {
      this.$Notice.error({ title: "请至少选中一条数据" });
      return;
    }

    var ids = this.selectedDataItems.map((x) => {
      return x.id;
    });
    this.czbdreq = new proxy.IdsDto();
    this.czbdreq.idList = ids;
    this.bdshow = true;
    this.googlecode = ''
  }
  ordersuccess(row) {
    var ids = [row.id];
    this.czbdreq = new proxy.IdsDto();
    this.czbdreq.idList = ids;
    this.bdshow = true;
    this.googlecode = ''
  }
  bud() {
    this.$Modal.confirm({
      title: "你确定进行补单吗?",
      onOk: () => {
        this.prox.batchOrderSuccess(this.googlecode, this.czbdreq).then(() => {
          this.$Notice.success({ title: "补单成功" });
          this.bdshow = false;
          this.getpage();
        });
      },
    });
  }
  exportrecord() {
    var ids = this.selectedDataItems.map((x) => {
      return x.id;
    });
    this.input.ids = ids;
    this.prox.export(this.input).then((x) => {
      location.href =
        AppConsts.remoteServiceBaseUrl +
        '/File/DownloadTempFile?FileToken=' +
        x.fileToken +
        '&fileName=' +
        x.fileName +
        '&fileType=' +
        x.fileType;
    });
  }

  getpage() {
    this.OnInit();
  }
  interv = 0;
  selecttitleschange() {
    this.columns = this.allcolumns.filter((x) =>
      this.selecttitles.includes(x.title)
    );
    localStorage.setItem("ordercolumns", JSON.stringify(this.selecttitles));
  }
  beforeMount() {
    let columnscache = localStorage.getItem("ordercolumns");
    if (!columnscache) {
      this.columns.push(...this.allcolumns);
      this.selecttitles = this.allcolumns.map((x) => {
        return x.title;
      });
    } else {
      let arr = JSON.parse(columnscache);
      this.selecttitles = arr;
      this.allcolumns.forEach((x) => {
        if (arr.indexOf(x.title) != -1) {
          this.columns.push(x);
        }
      });
    }

  }
  async created() {
    this.createrange = [
      new Date(new Date(new Date().toLocaleDateString()).getTime()),
      new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000),
    ];
    that = this;
    this.getpage();
    this.timer();

    setTimeout(() => {
      let req = new proxy.ChannelSimpleInputDto();
      new proxy.ChannelServiceProxy().queryAllList(req).then((x) => {
        this.PayChannels = x;
      });


      let mreq = new proxy.MerchantSimpleInputDto();
      new proxy.MerchantServiceProxy().queryAllList(mreq).then((x) => {
        this.merchants = x;
      });

      let creq = new proxy.ChannelTypePageInputDto();

      new proxy.ChannelTypeServiceProxy().queryAllTypes(creq).then((x) => {
        this.ctypes = x;
      });

      new proxy.ChannelSupplierServiceProxy().queryAllList().then(x => {
        this.supps = x;
      })

      this.prox.querySuccessTotal().then((x) => {
        this.successtotal = x;
      });

    }, 2000)


  }
  timer() {
    clearInterval(this.interv);
    this.interv = setInterval(() => {
      if (this.autorefresh) {
        this.getpage();
      }
    }, this.refreshsec * 1000);
  }
  setcomment() {
    this.prox.setComment(this.setcommentorder.id, this.comment).then((x) => {
      this.$Notice.success({ title: "备注成功" });
      this.getpage();
    });
  }
  showsetcomment(row) {
    this.setcommentorder = row;
    this.comment = row.orderCommont;
    this.modalsetcommentshow = true;
  }
  daifusubmit(row) {
    this.sub_id = row.id;
    this.createOrEditShow = true;
  }

  del() {
    //   if (this.selectedDataItems.length == 0) {
    //     this.$Notice.error({ title: '请至少选中一条数据' });
    //     return;
    //   }
    //   this.$Modal.confirm({
    //     title: '你确定要删除吗?删除后将无法恢复',
    //     onOk: () => {
    //       var ids = this.selectedDataItems.map(x => {
    //         return x.id;
    //       });
    //       this.prox.deletes(ids).then(() => {
    //         this.$Notice.success({ title: '删除成功' });
    //         this.getpage();
    //       });
    //     }
    //   });
  }

  czbdreq = new proxy.IdsDto();

  chongz() {
    this.$Modal.confirm({
      title: "你确定冲正清零吗?",
      onOk: () => {
        this.prox.chongZheng(this.googlecode, this.czbdreq).then(() => {
          this.$Notice.success({ title: "冲正成功" });
          this.czshow = false;
          this.getpage();
        });
      },
    });
  }
  signlecz(row) {
    var ids = [row.id];
    this.czbdreq = new proxy.IdsDto();
    this.czbdreq.idList = ids;
    this.czshow = true;
    this.googlecode = ''
  }
  cz() {
    if (this.selectedDataItems.length == 0) {
      this.$Notice.error({ title: "请至少选中一条数据" });
      return;
    }
    var ids = this.selectedDataItems.map((x) => {
      return x.id;
    });
    this.czbdreq = new proxy.IdsDto();
    this.czbdreq.idList = ids;
    this.czshow = true;
    this.googlecode = ''
  }
  notify() {
    if (this.selectedDataItems.length == 0) {
      this.$Notice.error({ title: "请至少选中一条数据" });
      return;
    }
    var ids = this.selectedDataItems.map((x) => {
      return x.id;
    });
    let req = new proxy.IdsDto();
    req.idList = ids;
    this.prox.orderNotice(req).then((x) => {
      this.$Notice.success({ title: "补发回调通知成功" });
    });
  }
  setupdatemoney() {
    var id = this.selectedDataItems[0].id;
    this.prox.updateOrderMoney(id, this.updateOrderMoney).then(x => {
      this.$Notice.success({ title: "订单金额修改成功" });
      this.getpage();
    })
  }
  updatemoney() {
    if (this.selectedDataItems.length == 0) {
      this.$Notice.error({ title: "请至少选中一条数据" });
      return;
    }
    if (this.selectedDataItems.length >= 2) {
      this.$Notice.error({ title: "修改订单不能选中多条数" });
      return;
    }
    this.updateOrderMoneyShow = true;

  }
}
